import { type DomainAccessControlConfig } from '../../../utils/domain/accessControl'
import { FeatureToggle } from '../../../access-control/featureToggles'

export const enterpriseStatusPageRetailerAccessControl: DomainAccessControlConfig = [
  {
    warehouseFeatureToggles: [FeatureToggle.rtEnterpriseStatusPageRetailer],
  },
]
